import { React } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../Context/AuthContext'
import Navbar from '../../components/nav/NavBar'
import Footer from '../../components/footer/Footer'
import SideMenu from '../../components/ProfileSideMenu/SideMenu'
import Vector from '../../assets/images/Vector.svg';

export default function RestEditPassword() {

    const form = useForm();
    const navigate = useNavigate();
    const { setNewPassword } = useAuth();
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = form;

    const password = watch('password', '');


    const onSubmit = async (data) => {
        const { password } = data;

        console.log('Data to send to API:', { password });

        let result = await setNewPassword({ password });
        if (result) {
            navigate('/profile-settings');
        }


        form.reset();
    };
    return (
        <>
            <Navbar />
            <div className='favourit-page-holder'>
                <div className='side-menu-component-holder'>
                    <SideMenu />
                </div>
                <div className='favourite-component-holder'>

                    <Link className='page-name-holder' to={'/edit-password'}>
                        <img className='edit-icon left-arrow' src={Vector} alt='arrow-icon' />
                        <p className='edit-link'>Edit Password</p>
                    </Link>
                    <div className='edit-password-holder reset'>
                        <form className='current-password-holder' onSubmit={handleSubmit(onSubmit)} noValidate>

                            <div className='edit-name edit-pass'>
                                <label className='edit-label'>Password</label>
                                <input
                                    className='edit-input'
                                    type="password"
                                    placeholder="Enter your password"
                                    {...register("password", {
                                        required: true,
                                        validate: {
                                            checkLength: (value) => value.length >= 6,
                                            matchPattern: (value) =>
                                                /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#_-|$*])/.test(
                                                    value
                                                )
                                        }
                                    })}
                                />
                                {errors.password && errors.password.type === "required" && (
                                    <p className="errorMsg">Password is required.</p>
                                )}
                                {errors.password && errors.password.type === "checkLength" && (
                                    <p className="errorMsg">
                                        Password should be at-least 10 characters.
                                    </p>
                                )}
                                {errors.password && errors.password.type === "matchPattern" && (
                                    <p className="errorMsg">
                                        Password must contain atleast Capital char and Specail char.
                                    </p>
                                )}

                            </div>
                            <div className='edit-name edit-pass'>
                                <label className='edit-label'>Confirm Password</label>

                                <input
                                    className='edit-input'
                                    type="password"
                                    placeholder="Enter your password again "
                                    {...register("confirmPassword", {
                                        required: true,
                                        validate: value => value === password || "Passwords do not match"
                                    })}
                                />
                                {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                                    <p className="errorMsg">Confirm password is required.</p>
                                )}
                                {errors.confirmPassword && errors.confirmPassword.type === "validate" && (
                                    <p className="errorMsg">Passwords do not match.</p>
                                )}



                            </div>


                            <div className='save-btn-holder edit-password-page'>
                                <button className='save-button ' type="submit">Confirm</button>
                            </div>
                        </form>


                    </div>


                </div>
            </div>
            <Footer />
        </>
    )
}
